import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';

import DiariasBlockData from './Data';
import DiariasBlockView from './View';

const DiariasBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  return (
    <>
      <DiariasBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <DiariasBlockData
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(DiariasBlockEdit);
